import React from "react";
import PropTypes from "prop-types";
import Account from "./Account.jsx";

class Select extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  
  handleChange(e) {
    for (let i = 0; i < this.props.options.length; i++) {
      if (this.props.options[i].label === e.target.value) {
        this.props.setValue(this.props.options[i].value);
        break;
      }
    }
  }
  
  render() {
    let currentLabel = '';
    for (let i = 0; i < this.props.options.length; i++) {
      if (this.props.options[i].value === this.props.value) {
        currentLabel = this.props.options[i].label;
        break;
      }
    }
    
    return (
      <select 
        value={currentLabel}
        onChange={this.handleChange}
        className="w-full bg-slate-800 text-slate-200 border border-slate-700 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 focus:border-blue-500 focus:outline-none"
      >
        {this.props.options.map(option => (
          <option key={option.value} value={option.label}>
            {option.label}
          </option>
        ))}
      </select>
    );
  }
}

class CategoryFeed extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      accounts: [],
      response: null,
      show: "all",
      isLoading: false,
      error: null,
      page: 1,
      hasMore: true,
      lastFetchedPage: 0,
      totalAccounts: 0
    };

    this.options = [
      { value: "all", label: "Все типы" },
      { value: "single", label: "Одиночные посты" },
      { value: "slider", label: "Карусель (Галерея)" },
      { value: "single-video", label: "Видео" }
    ];
    
    this.setValue = this.setValue.bind(this);
    this.fetchAccounts = this.fetchAccounts.bind(this);
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount() {
    const urlParams = new URLSearchParams(window.location.search);
    const typeParam = urlParams.get("type") || "all";
    
    window.addEventListener('scroll', this.handleScroll);
    this.fetchAccounts(typeParam);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  handleScroll() {
    if (this.state.isLoading || !this.state.hasMore) return;

    const scrolled = window.scrollY;
    const viewportHeight = window.innerHeight;
    const fullHeight = document.documentElement.scrollHeight;

    if (scrolled + viewportHeight >= fullHeight - 300) {
      this.setState(
        prevState => ({ page: prevState.page + 1 }),
        () => this.fetchAccounts(this.state.show, true)
      );
    }
  }

  fetchAccounts(type, append = false) {
    // Проверяем, не загружаем ли мы уже что-то
    if (this.state.isLoading) return;

    // Проверяем, есть ли еще данные для загрузки при подгрузке
    if (append && !this.state.hasMore) return;

    // Проверяем, не загружали ли мы уже эту страницу
    if (this.state.lastFetchedPage === this.state.page) return;

    this.setState({ isLoading: true, error: null });

    const token = document.querySelector('[name=csrf-token]');
    if (!token) {
      this.setState({ 
        error: "CSRF токен не найден", 
        isLoading: false 
      });
      return;
    }

    const requestOptions = {
      method: 'POST',
      headers: { 
        'Content-Type': 'application/json',
        'X-CSRF-TOKEN': token.content,
      },
      body: JSON.stringify({ 
        category_id: this.props.category_id, 
        type: type,
        page: this.state.page
      })
    };

    fetch("/api/fetch_accounts", requestOptions)
      .then(res => {
        if (!res.ok) {
          throw new Error('Ошибка сети');
        }
        return res.json();
      })
      .then(result => {
        if (!result.accounts || !result.accounts.data) {
          throw new Error('Неверный формат данных');
        }
        
        const newAccounts = result.accounts.data;

        let total = 0;
        if (result.accounts.meta && result.accounts.meta.total) {
          total = result.accounts.meta.total;
        }

        this.setState(prevState => {
          if (append) {
            // Проверяем на дубликаты при добавлении новых аккаунтов
            const existingIds = new Set(prevState.accounts.map(account => account.id));
            const uniqueNewAccounts = newAccounts.filter(account => !existingIds.has(account.id));

            return {
              accounts: [...prevState.accounts, ...uniqueNewAccounts],
              isLoading: false,
              hasMore: uniqueNewAccounts.length > 0,
              lastFetchedPage: prevState.page,
              totalAccounts: total
            };
          }

          return {
            accounts: newAccounts,
            isLoading: false,
            hasMore: newAccounts.length > 0,
            lastFetchedPage: prevState.page,
            totalAccounts: total
          };
        });
      })
      .catch(error => {
        this.setState({ 
          error: error.message, 
          isLoading: false 
        });
      });
  }

  setValue(value) {
    this.setState({
      show: value, 
      accounts: [],
      page: 1,
      hasMore: true,
      lastFetchedPage: 0
    }, () => this.fetchAccounts(value));
  }

  render() {
    const { accounts, isLoading, error, totalAccounts } = this.state;

    return (
      <div className="w-full">
        <div className="sm:pt-0 pt-2 px-4 mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center justify-between space-y-4 sm:space-y-0">
            <div className="flex flex-col sm:flex-row sm:items-center space-y-3 sm:space-y-0 sm:space-x-4">
              <h3 className="text-sm font-medium text-slate-400">Опции отображения</h3>
              <div className="w-full sm:w-48">
                <Select 
                  options={this.options} 
                  value={this.state.show} 
                  setValue={this.setValue} 
                />
              </div>
            </div>
            <div className="text-xs text-slate-500">
              {totalAccounts} аккаунтов
            </div>
          </div>
        </div>
  
        <div className="space-y-8 px-0 sm:px-4">
          {accounts.map(account => (
            <Account 
              key={account.id}
              account={account.attributes} 
            />
          ))}

          {isLoading && (
            <div className="text-center py-8">
              <div className="text-sm text-slate-400">Загрузка...</div>
            </div>
          )}

          {error && (
            <div className="text-center py-8 text-red-500">
              <div className="text-sm">{error}</div>
            </div>
          )}

          {!isLoading && !error && accounts.length === 0 && (
            <div className="text-center py-12">
              <div className="text-2xl text-slate-500 mb-2">
                <i className="far fa-folder-open"></i>
              </div>
              <p className="text-sm text-slate-400">Аккаунты не найдены</p>
            </div>
          )}
        </div>
      </div>
    );
  }
}

CategoryFeed.propTypes = {
  category_id: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number
  ]).isRequired
};

export default CategoryFeed;